<template>
  <div class="cotent_app">
    <div class="content_top">
      <img :src="category.dingimg" alt="" class="w100" />
      <!-- <h3>{{category.cat_name}}</h3> -->
    </div>
    <div class="content_center">
      <div class="container">
        <div class="text_box1">
          <h3 class="custom-title">{{ category.cat_name }}</h3>
          <!-- <img
            src="@/assets/images/appliction/mining/10.png"
            alt=""
            class="content-img"
          /> -->
        </div>
        <div class="content-bottom">
          <div class="text_box">
            <h3 class="custom-title">{{ category.cat_name }}</h3>
            <p>
              {{ category.description }}
            </p>
          </div>

          <div class="swiper-box">
            <div class="swiper-container mySwiper2 mobile">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in piclist"
                  :key="index"
                >
                  <img :src="item.show_img" class="w100 top-img" />
                </div>
              </div>
            </div>
            <div class="swiper-bottom-box">
              <div thumbsSlider="" class="swiper-container mySwiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in piclist"
                    :key="index"
                  >
                    <img
                      class="w100 pc"
                      :src="item.show_img"
                      alt=""
                      @click="imgYu(item.show_img)"
                    />
                    <img class="w100 mobile" :src="item.show_img" alt="" />
                  </div>
                </div>
                <div class="swiper-pagination" slot="pagination"></div>
              </div>
              <div class="swiper-button-next swiper-button-next3 mobile"></div>
              <div class="swiper-button-prev swiper-button-prev3 mobile"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <p class="break-all">
          {{ category.description }}
        </p>
      </div>
    </div>
    <div class="yzbox" @click="hideYu()">
      <img src="" alt="" id="yz" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swiper from "swiper";

export default {
  props: ["productName"],
  data() {
    return {
      category: "",
      cid: 0,
      banner: "",
      piclist: [],
    };
  },
  async created() {
    await this.fetchDetailData();
  },
  methods: {
    imgYu(src) {
      $(".yzbox img").attr("src", src);
      $(".yzbox").show();
    },
    hideYu(src) {
      $(".yzbox").hide();

      $(".yzbox img").attr("src", "");
    },
    async fetchDetailData() {
      // 模拟异步数据获取，实际使用时替换为真实的 API 请求
      setTimeout(() => {
        // 这里可以根据 $route.params.id 获取对应的数据
        this.detailData = { id: this.$route.params.productName };
        var that = this;

        var cid = 1;
        var cidlist = [
          "mining",
          "cement-plant",
          "power-plant",
          "port",
          "steel-mill",
          "bulk-material-handling",
        ];
        for (var i = 0; i < 6; i++) {
          if (that.$route.params.productName == cidlist[i]) {
            cid = i + 1;
          }
        }
        console.log(that.$route.params.productName);
        console.log("在这里");
        console.log(cid);

        axios({
          method: "post",
          url: `${this.$apiYf}/artilecategoryapi.php`,
          data: {
            cid: cid,
          },
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          that.category = res.data.category;
          that.piclist = res.data.piclist;
          document.title = that.category.pagetitle;
          document.querySelector('meta[name="keywords"]').setAttribute('content', that.category.keywords)
          document.querySelector('meta[name="description"]').setAttribute('content', that.category.description)
          that.$nextTick(() => {
            let isMobile = false;
            let option = {};
            var lbSwiper = null;
            if (
              navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
              )
            ) {
              isMobile = true;
              option = {
                // loop: true,
                spaceBetween: 8,
                slidesPerView: 3,
                // freeMode: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                // loopedSlides: 7, // 通常是主图的 slides 数量
                // centeredSlides: true,
                watchSlidesProgress: true,
              };
            } else {
              isMobile = false;
              option = {
                loop: !isMobile,
                autoplay: !isMobile,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                autoHeight: true,
                centeredSlides: !isMobile,
                speed: 500,
                slidesPerView: "auto",
                roundLengths: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                calculateHeight: true,
                watchSlidesVisibility: true, //防止不可点击
                on: {
                  slideChangeTransitionEnd: function() {},
                },
              };
            }

            lbSwiper = new Swiper(".mySwiper", option);
            var swiper2 = new Swiper(".mySwiper2", {
              // spaceBetween: 24,
              // loopedSlides: 7, // 通常是主图的 slides 数量
              thumbs: {
                swiper: lbSwiper,
              },
            });
            that.$emit("loaded");
          });
        });
      }, 500);
    },
  },
  watch: {
    productName: {
      immediate: true,
      async handler(newId) {
        this.productName = newId;
        await this.fetchDetailData();
      },
    },
  },
  mounted() {
    this.fetchDetailData();
  },
};
</script>

<style lang="scss">
.cotent_app {
  @media (max-width: 768px) {
    .mySwiper2 {
      .swiper-slide {
        width: 100% !important;
        margin: 0 !important;
      }
    }
    .swiper-bottom-box {
      position: relative;
    }
    .mySwiper {
      width: 80%;
      margin: 10px auto;

      .swiper-slide {
        // width: 80% !important;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      border-radius: 0 !important;
      width: calc(23px) !important;
      height: calc(136px / 2) !important;
      // height: calc(100% - 30px) !important;
      top: 22px !important;
      right: 0 !important;
      background: #eeefef !important;
    }
    .swiper-button-next3,
    .swiper-button-prev3 {
      background: #efefef;
      bottom: 0;
      top: 0;
      left: 0;
      width: 5%;
      height: 6.6vw;
      &.swiper-button-disabled {
        opacity: 1;
      }
      &::after {
        position: absolute;
        content: "prev";
        color: #666666;
        font-size: 12px;
        font-family: swiper-icons;
      }
    }
    .swiper-button-prev3 {
      left: 0 !important;

      &::after {
        font-size: 12px !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%);
      }
    }
    .swiper-button-next3 {
      right: 0;
      left: auto;
      &::after {
        position: absolute;
        content: "next";
        font-size: 12px !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%);
      }
    }
  }
  @media (max-width: 768px) {
    .content_top {
      img {
      }
    }
    .custom-title {
      margin-bottom: 20px !important;
    }
    .content {
      display: block !important;
      width: 90%;
      margin: 0 auto;
      font-size: 12px !important;
      line-height: 18px !important;
    }
  }

  .content_center {
    .content {
      display: none;
    }

    .container {
      //       display: flex;
      //       margin: 5vw auto 3vw;
      //       align-items: flex-start;
      .content-bottom {
        display: flex;
        margin: 5vw auto 3vw;
        align-items: flex-start;
      }
      .swiper-box {
        width: 60%;
      }
      @media (max-width: 768px) {
        .swiper-box {
          width: 100%;
        }
        width: 90%;
        flex-wrap: wrap;
        .swiper-container {
          // width: ;
        }
        .text_box {
          display: none !important;
        }
        .text_box1 {
          display: block !important;
          width: 100% !important;
          //   margin-right: 0 !important;
          margin-top: 34px;
          h3 {
            margin-bottom: 10px !important;
          }
          .content-img {
            //     width: 100%;
          }
        }
        .content {
          display: block;
          width: 90%;
          margin: 0 auto;
        }
      }
      .text_box1 {
        display: none;
      }
      .text_box1,
      .text_box {
        width: 40%;
        margin-right: 5%;
        h3 {
          font-size: 48px;
          color: #ad1f24;
          margin-bottom: 44px;
          position: relative;
          line-height: 1.8;

          &::after {
            content: "";
            border-bottom: solid 4px #ad1f24;
            width: 120px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        p {
          font-size: 16px;
          line-height: 2;
        }
      }
    }
    .swiper-container {
      flex: 1;
      overflow: hidden;
      position: relative;
      .swiper-wrapper {
        width: 100%;
        .swiper-slide {
          width: 80%;
          overflow: hidden;
          margin: 0 1%;

          img {
            opacity: 0.9;
          }
          &:hover {
            img {
              opacity: 1;
            }
          }
        }
      }
      .swiper-pagination {
        text-align: center;
        position: relative;
        bottom: 0;
        margin-top: 10px;
        span.swiper-pagination-bullet {
          width: 20px;
          height: 5px;
          border-radius: 0;
          opacity: 1;
          background: #aaa;
          display: inline-block;
          &.swiper-pagination-bullet-active {
            background: #333;
          }
        }
      }
    }
  }
  .yzbox {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.7);
    display: none;
    img {
      width: 80%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      display: block;
      margin: auto;
    }
  }
}
</style>
